const DELAY = 300

/**
 * @param callback
 * @param options
 * @param options.delay
 */
export default function runAfterDelayPerformanceUtil (callback, options = {}) {
  const delay = options.delay || DELAY
  setTimeout(callback, delay)
}
